module.exports = __webpack_public_path__ + "fonts/288ad9c6e8b43cf02443a1f499bdf67e.woff";